import React, { createRef, useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getMotkeMember, login } from "../../../services/accountService";
import http from "../../../services/httpService";
import { loginProps } from "../../../typings/login";
import { SIGNUP } from "../../../navigation/Constants";
import { useDispatch, useSelector } from "react-redux";
import { setLoginComplete } from "./../../../redux/app";
import Loader from "react-loader-spinner";
import { validate, validateEmail } from "../../../helpers/Validators";
import NiceModal from "@ebay/nice-modal-react";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { VALIDATOR_REQUIRE } from "../../../helpers/Validators";
import { VALIDATOR_EMAIL } from "./../../../helpers/Validators";
import { RootState } from "../../../redux/store";
import { setSignupData } from "../../../redux/signup";
import { sendMessageToWebview } from "../../../services/native";
import ReCAPTCHA from "react-google-recaptcha";

const LoginForm = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordShown, setPasswordShown] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const register = useSelector((state: RootState) => state.signup);
  const recaptchaRef: any = useRef(null);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const validateForm = () => {
    let errors: any = {};
    if (!validate(email, [VALIDATOR_REQUIRE()])) {
      errors["email"] = "חובה להזין דואר אלקטרוני";
    }
    if (!validate(email, [VALIDATOR_EMAIL()])) {
      errors["email"] = "כתובת דואר אלקטרוני לא תקינה";
    }
    if (!validate(password, [VALIDATOR_REQUIRE()])) {
      errors["password"] = "חובה להזין סיסמה";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getDate = (date: string) => {
    const d = date.slice(0, 10).split("-");
    return `${d[2]}/${d[1]}/${d[0]}`;
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    recaptchaRef.current.reset();
    var capchaToken = await recaptchaRef.current.executeAsync();

    if (validateForm()) {
      const schame: loginProps = {
        email: email,
        password: password,
        registrationTypeId: 1,
        recaptchaToken: capchaToken,
      };
      try {
        // login (auth)
        setShowLoader(true);
        const { data } = await login(schame);

        localStorage.setItem("token", data.accessToken);
        localStorage.setItem("refresh_token", data.refreshToken);
        http.setJwt(data.accessToken);
        dispatch(setLoginComplete(true));
        if (window.platform === "ios" || window.platform === "android") {
          sendMessageToWebview("auth");
          sendMessageToWebview("auth-token", { token: data.accessToken });
        }
        setShowLoader(false);
      } catch (error: any) {
        if (error.response.status === 404) {
          setShowLoader(false);
          detailsNotValid();
        }
      }

      // catch (error: any) {
      //   if (error.response.status === 404) {
      //     try {
      //       const { data } = await getMotkeMember(schame);
      //       register.aboutMe = `${data.about_Me}\n\n${
      //         data.looking_For !== null ? data.looking_For : ""
      //       }`;
      //       register.email = schame.email;
      //       register.date_of_birth = getDate(data.date_of_Birth);
      //       register.nickName = data.name;
      //       register.genderId = data.gender === "m" ? 5 : 15;
      //       dispatch(setSignupData(register));
      //       history.push(SIGNUP);
      //     } catch (err) {
      //       if (error.response.status === 404) {
      //         setShowLoader(false);
      //         detailsNotValid();
      //       }
      //     }
      //   }
      // }
    }
  };

  const detailsNotValid = () => {
    const seconderyErrorContentText = () => {
      return (
        <div>
          <p style={{ margin: "0px" }}>המייל או הסיסמה שמילאת לא נכונים.</p>
          <p style={{ margin: "0px" }}>כמה טיפים מאיתנו:</p>
          <p style={{ margin: "0px" }}>-לוודא שהקלדת באנגלית</p>
          <p style={{ margin: "0px" }}>-להקפיד על אותיות קטנות וגדולות</p>
        </div>
      );
    };

    NiceModal.show("error_modal", {
      headerTitle: "שגיאה",
      errorContent: "משהו בפרטים לא מדויק",
      seconderyErrorContent: seconderyErrorContentText(),

      seconderyButtonText: "בעצם לא",
      primaryButtonText: "הבנתי",
    });
  };

  const redirectToSignUp = () => {
    history.push(SIGNUP);
  };

  const link = usePrepareLink({
    state: {
      navigateFromProfile: true,
    },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.findYourAccount,
    },
    keepOldQuery: true,
  });

  const enabled = email.length > 0 && password.length > 0;

  return (
    <>
      <form>
        <ReCAPTCHA
          sitekey="6LeDwfAjAAAAAK1h9r6f_bJHp-k0oGC6R9QvSqap"
          size="invisible"
          ref={recaptchaRef}
        />
        <div className="form_field_content login">
          <div className="field_block">
            {/* <label htmlFor="name">מייל</label> */}

            <input
              autoComplete="off"
              name="email"
              inputMode="email"
              type="email"
              dir="ltr"
              value={email}
              placeholder={"מייל"}
              onChange={(e) => {
                setErrors({});
                setEmail(e.target.value);
              }}
              maxLength={256}
              className="txt_field mail w-input"
            />
            <div
              className="form_allert"
              style={{
                display: errors && errors["email"] ? "contents" : "block",
              }}
            >
              {errors["email"]}
            </div>
          </div>
          <br />
          <div className="field_block">
            {/* <label htmlFor="password">סיסמה</label> */}
            <input
              autoComplete="off"
              name="password"
              type={passwordShown ? "text" : "password"}
              value={password}
              placeholder={"סיסמה"}
              onChange={(e) => {
                setErrors({});
                setPassword(e.target.value);
              }}
              maxLength={256}
              className="txt_field password w-input"
            />
            <div
              className="form_allert"
              style={{
                display: errors && errors["password"] ? "contents" : "block",
              }}
            >
              {errors["password"]}
            </div>
          </div>
          <div className="form_buttons_group check">
            <label className="w-checkbox checkbox_field w-clearfix">
              <div
                className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox ${
                  passwordShown ? "w--redirected-checked" : ""
                }`}
              />
              <input
                onClick={togglePasswordVisiblity}
                type="checkbox"
                id="checkbox"
                name="checkbox"
                data-name="Checkbox"
                style={{ opacity: 0, position: "absolute", zIndex: -1 }}
              />
              <span className="checkbox_label w-form-label">הצג סיסמה</span>
            </label>
            <Link to={link} className="forgot_link">
              שכחתי את הסיסמה שלי
            </Link>
          </div>
        </div>
        <div className="form_buttons_group">
          {showLoader ? (
            <button disabled={true} className="button_full w-button">
              <Loader type="Oval" color="white" height={22} width={30} />
            </button>
          ) : (
            <input
              autoComplete="off"
              disabled={!enabled}
              type="submit"
              value="כניסה"
              data-wait
              className={
                enabled
                  ? "button_full w-button"
                  : "button_full inactive  w-button"
              }
              onClick={(e) => handleSubmit(e)}
            />
          )}
          {/* <input autoComplete="off"
                        type="button"
                        value=" רוצה להירשם ל-Bounakir"
                        onClick={redirectToSignUp}
                        data-wait
                        className="button_full w-button"
                    /> */}
        </div>
      </form>
    </>
  );
};

export default LoginForm;
